
import styled from "styled-components"

const StyledCircle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.bgColor};
    width: 80px;
    height: 80px;
    border-radius: 50%;
    color:  ${props => props.color};;
`;

export function ColorCircle({ color, bgColor, children }) {
    return (
        <StyledCircle color={color} bgColor={bgColor}>
            {children}
        </StyledCircle>
    );
}

